// extracted by mini-css-extract-plugin
export default {"main":"Header_main__RM57S","email":"Header_email__myD-O","mobile":"Header_mobile__gOxom","tdecor":"Header_tdecor__gxJ0S","icon":"Header_icon__EPUej","time":"Header_time__eqLOX"};